import { useEffect } from 'react';

const usePageTitle = (title) => {
    useEffect(() => {
        const appName = process.env.REACT_APP_APP_NAME || 'Rannkly Widget';
        const pageTitle = title ? `${title} - ${appName}` : appName;
        document.title = pageTitle;

        // Cleanup function to reset title if needed
        return () => {
            document.title = appName;
        };
    }, [title]);
};

export default usePageTitle;
